<li class="nav-item dropdown">
    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown1" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i *ngIf="menu.icon" [class]="menu.icon"></i> {{ menu.nome }}
    </a>
    <div class="dropdown-menu" [ngClass]="bg" aria-labelledby="navbarDropdown1">
      <ng-container *ngFor="let m of menu.menuItens">
          <div *ngIf="m.divider; else noDivider" class="dropdown-divider"></div>
        <ng-template #noDivider>
          <a *ngIf="!m.menuItens" class="dropdown-item" [routerLink]="m.link"> <i *ngIf="m.icon" [class]="m.icon"></i> {{ m.nome }}</a>
          <app-menu-modulo-subitem2 [bg]="bgSub" *ngIf="m.menuItens" [menu]="m"></app-menu-modulo-subitem2>
        </ng-template>
      </ng-container>
    </div>
  </li>
